module.exports = __webpack_public_path__ + "Lato-Regular.8ab18d934cfa1e51dc82.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Regular.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Regular.eot
// module chunks = styles